// extracted by mini-css-extract-plugin
module.exports = {"container":"_3976ac72","message":"_a44355fe","countdown":"_bf764cc4","onHold":"_be1d7dfb","sold":"_63ab4001"};